define('GameDayCore/GDModel/ValueObjects/Linescore/LinescoreHomeruns',['require','exports','module','../ValueObjectFactory'],function(require, exports, module) {
	var VO = require('../ValueObjectFactory');

	VO.create(LinescoreHomeruns);

	function LinescoreHomeruns($data, home_code, away_code) {
		var vo = VO.ensureVO(this, LinescoreHomeruns),
			data = $data,
			hasHomeruns = false,
			codes = {},
			home_away = {
				home : [],
				away : []
			};
		codes[home_code] = "home";
		codes[away_code] = "away";
		if(data && data.player){
			var i=0,
				sort = {},
				home_runs = Array.isArray(data.player) ? data.player : [data.player],
				hitter,
				team,
				len = home_runs.length;

			hasHomeruns=true;
			for(; i < len; i++){
				hitter = home_runs[i];
				team = codes[hitter.team_code];
				// displayed in order of occurance
				// aggregate multiple homeruns to their earlier entry
				if (sort[hitter.id] !== undefined) {
					home_away[team].splice(sort[hitter.id], 1);
				} else {
					sort[hitter.id] = home_away[team].length;
				}
				home_away[team].push({
					player 		: {
						id 	 		: hitter.id,
						name 	: {
							last	: hitter.last,
							first	: hitter.first,
							boxname : hitter.name_display_roster
						},
						seasonStats : {
							batting : {
								homeRuns : hitter.std_hr
							}
						}
					},
					detail  	: hitter.hr > 1 ? hitter.hr : null
				});				
			}

		}
		vo.hasHomeruns = hasHomeruns;
		vo.away = home_away.away.length ? home_away.away : null;
		vo.home = home_away.home.length ? home_away.home : null;
	}

	return LinescoreHomeruns;
});
